import { BaseComponent } from '../base-component'
import { $el } from 'src/scripts/utils/utils'

const INPUT_SELECTOR = `[data-password-field-input]`
const BUTTON_SELECTOR = `[data-password-field-button]`

export class PasswordField extends BaseComponent {
  mountComponent(): void {
    const button = $el(BUTTON_SELECTOR, this)
    this.addListener(button, 'click', this.handleButtonClick)
  }

  handleButtonClick = (event: MouseEvent): void => {
    event.preventDefault()
    this.togglePasswordVisible()
  }

  togglePasswordVisible(): void {
    const input = $el(INPUT_SELECTOR, this)

    if (input) {
      const isHidden = input.getAttribute('type') === 'password'
      input.setAttribute('type', isHidden ? 'text' : 'password')
      this.setHiddenButton(isHidden)
    }
  }

  setHiddenButton(isHidden: boolean): void {
    const button = $el(BUTTON_SELECTOR, this)
    button?.toggleAttribute('password-visible', isHidden)
  }
}
